import * as Yup from 'yup';

const FundraisingTransactionValidator = () => Yup.object().shape({
  title: Yup.string().required(),
  ambassador_id: Yup.string(),
  contact_id: Yup.string().required(),
  donor_name_displayed: Yup.string(),
  amount_multiplier: Yup.string(),
  pledge_date: Yup.date(),
  source_reference: Yup.string(),
  source_reference_url: Yup.string(),
  donor_comment: Yup.string(),
});

export const FundraisingLinkValidator = () => Yup.object().shape({
  event_id: Yup.string()
    .when('is_linked', {
      is: (link: boolean) => link,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  donor_name_displayed: Yup.string()
    .when('is_linked', {
      is: (link: boolean) => link,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});

export default FundraisingTransactionValidator;
